import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { MyErrorStateMatcher } from 'src/app/shared/app-classes';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {
  forgetForm: any;
 
  submitted = false ;
  matcher = new MyErrorStateMatcher();

  constructor(private titleService: Title,private auth: AuthService,  private router: Router, public snackBar: MatSnackBar) { }
  
  ngOnInit() {
    this.forgetForm  = new FormGroup ({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
    this.titleService.setTitle( 'Forget Password' );
  }
  resetPassword(){
    if (this.forgetForm.valid) {
      this.auth.doResetPassword(this.forgetForm.controls['email'].value)
      .then(res=>{
        this.snackBar.open("An e-mail was sent to "+this.forgetForm.controls['email'].value+ " avec des instructions supplémentaires.", '',{duration: 2000});
        setTimeout(() => { this.router.navigate(['/auth/login'])}, 3000);
        
      }).catch(e=>
        {
        this.snackBar.open("The account with this email address does not exist.", '',{duration: 2000});
        });
    }
  }
  previous(){}
}